"use strict";

// popstate events caused by our own history.go() - the stack and the UI are
// already up to date by the time they arrive, so they must not unwind again.
let pendingUnwinds = 0;
// window-level handlers must only ever be bound once, even if initInScope re-runs
let globalHandlersBound = false;

export function initInScope ($scope) {

    let allModals = $scope.find(".modal");

    allModals.on("show.bs.modal", function(e) {
        let modalId = $(this).attr("id");
        _config.hashStack.push(modalId);
        history.pushState({ hashStack: _config.hashStack.slice() }, '', "#" + modalId);
    });

    allModals.on("hide.bs.modal", function(e) {
        closeEntry($(this).attr("id"));
    });

    allModals.on("hidden.bs.modal", function(e) {
        if($(".modal.show").length > 0) {
            $("body").addClass("modal-open");
        }
    });

    if (!globalHandlersBound) {
        globalHandlersBound = true;
        $(window).on("popstate", function(e) {
            if (pendingUnwinds > 0) {
                // our own history.go() - already handled, just absorb it
                pendingUnwinds--;
                return;
            }
            if (_config.hashStack.length === 0) {
                return;
            }
            // browser back closes exactly one level. Pop BEFORE closing so the
            // hide.bs.modal / onCloseAfter.lg it triggers see it as already handled.
            let idToClose = _config.hashStack.pop();
            closeUi(idToClose, $scope);
        });
    }

    // deep link: /page#galleryPreview should actually open the gallery
    let initialHash = (location.hash || '').replace('#', '');
    if (initialHash && $scope.find("#" + initialHash).hasClass("modal")) {
        _config.hashStack = [];
        history.replaceState({ hashStack: [] }, '', location.pathname + location.search);
        $scope.find("#" + initialHash).modal("show");
    }
}

/**
 * Something closed itself - X button, ESC, backdrop click, lightGallery's own close.
 *
 * Removes it AND everything stacked on top of it from both the hashStack and the
 * browser history. Closing out of order matters: pressing ESC while the lightbox is
 * open makes Bootstrap hide #galleryPreview while 'lightgallery' is still on top of
 * the stack, so we have to unwind two entries in one go, not one.
 *
 * Safe to call for something that is no longer on the stack - that is what makes
 * cascading closes (modal hides -> lightbox closes too) collapse into a single unwind.
 */
export function closeEntry(id) {
    let i = _config.hashStack.lastIndexOf(id);
    if (i === -1) {
        return; // not tracked, or already unwound by a cascading close
    }
    let steps = _config.hashStack.length - i;
    _config.hashStack.splice(i, steps);
    pendingUnwinds++;
    history.go(-steps); // one popstate, however many steps
}

function closeUi(id, $scope) {
    if (id === "lightgallery") {
        let lgClose = $scope.find(".lg-visible .lg-close");
        if (lgClose.length > 0) {
            lgClose.trigger("click");
        }
    } else if (id === "pullup") {
        let pullup = $(".portal-search-mobile-pullup");
        $("body").removeClass("modal-open");
        pullup.removeClass("open");
        let sticky = $(".objekt-detail-sticky .js-objekt-detail-submit-form");
        updateUrlParams({
            from: sticky.find('input[name="from"]').val(),
            to: sticky.find('input[name="to"]').val(),
            persons: sticky.find('input[name="persons"]').val()
        }, { replace: true });
    } else if ($("#" + id).length > 0) {
        $("#" + id).modal("hide");
    }
}

function updateUrlParams(params, { replace = false } = {}) {
    const url = new URL(window.location.href); // keeps path + hash
    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') {
            url.searchParams.delete(key);         // remove if empty/null
        } else {
            url.searchParams.set(key, String(value)); // add/update
        }
    });
    history[replace ? 'replaceState' : 'pushState']({}, '', url);
}
